var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4411 15.2217C16.0803 14.0715 15.3 12.3903 15.3 10.6092V8.1C15.3 4.9329 12.9474 2.3112 9.9 1.872V0.9C9.9 0.4023 9.4968 0 9 0C8.5032 0 8.1 0.4023 8.1 0.9V1.872C5.0517 2.3112 2.7 4.9329 2.7 8.1V10.6092C2.7 12.3903 1.9197 14.0715 0.5508 15.2289C0.2007 15.5286 0 15.9642 0 16.425C0 17.2935 0.7065 18 1.575 18H16.425C17.2935 18 18 17.2935 18 16.425C18 15.9642 17.7993 15.5286 17.4411 15.2217Z",
    fill: "#A58450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 21.6004C10.6299 21.6004 11.9934 20.4385 12.3066 18.9004H5.69336C6.00656 20.4385 7.37006 21.6004 8.99996 21.6004Z",
    fill: "#A58450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6c80053728c4962854415323d4424323.svg";
export { ForwardRef as ReactComponent };